<template lang="pug">
.b-base-table-header-item.cell(@click="sortBy" :class="{ sortable: !!header.sortFn }")
  slot
  .title(v-if="header.title") {{ header.title }}
  Icon._sort(v-if="header.sortFn" :name="sort ? 'sort-active' : 'sort'" :class="[ order ? 'asc' : 'desc' ]" pointer)
</template>

<script>
import BaseSelect from '@/components/BaseSelect.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'BaseTable',
  components: { BaseSelect, EmptyList },
  props: {
    header: Object,
    sort: Boolean,
    order: Boolean,
  },
  methods: {
    sortBy() {
      if (!this.header.sortFn) return;
      this.$emit('sort', this.header);
    },
  },
};
</script>

<style scoped lang="scss">

.base-table-header-item {
  display: flex;
  align-items: center;
  gap: 10px;

  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #92A0B0;

  &.sortable {
    cursor: pointer;

    &:hover {
      color: #33A1FB;
    }
  }

  &__sort {
    &.desc {
      transform: rotate(180deg);
    }
  }
}
</style>
